import { render, staticRenderFns } from "./frequent_items_search_input.vue?vue&type=template&id=57806e75&"
import script from "./frequent_items_search_input.vue?vue&type=script&lang=js&"
export * from "./frequent_items_search_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports